export default __webpack_public_path__ + "static/media/foreign-language-bg-small.ec4031ce.webp";